import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideoCamera = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.2687 1.69133C14.818 1.466 14.2867 1.51333 13.884 1.81667C13.858 1.836 13.8333 1.858 13.8107 1.88067L12.6393 3.06267C12.4987 1.35267 11.0787 0 9.33333 0H3.33333C1.49533 -0.000666444 0 1.49467 0 3.33267V7.33267C0 9.17067 1.49533 10.666 3.33333 10.666H9.33333C11.086 10.666 12.512 9.30133 12.6413 7.58133L13.812 8.75067C13.8347 8.77267 13.858 8.79267 13.8833 8.812C14.118 8.988 14.3953 9.07733 14.6753 9.07733C14.8773 9.07733 15.0793 9.03133 15.2687 8.93667C15.72 8.71133 16 8.25733 16 7.754V2.87533C16 2.37067 15.72 1.91667 15.2687 1.69133ZM9.33333 9.33267H3.33333C2.23067 9.33267 1.33333 8.43533 1.33333 7.33267V3.33267C1.33333 2.23 2.23067 1.33267 3.33333 1.33267H9.33333C10.436 1.33267 11.3333 2.23 11.3333 3.33267V7.33267C11.3333 8.43533 10.436 9.33267 9.33333 9.33267ZM12.6667 5.72133V4.92867L14.6667 2.91L14.6833 7.73533L12.6667 5.72067V5.72133Z",
		fill: "currentColor"
	})
});
export default SvgVideoCamera;
